import CopyButton from "@components/buttons/CopyButton";

export function truncateMiddle(
  value: string,
  startChars = 8,
  endChars = 8,
): string {
  const text = value.trim();
  if (text.length <= startChars + endChars + 3) return text;
  return `${text.slice(0, startChars)}...${text.slice(-endChars)}`;
}

type TruncatedCopyValueProps = {
  value?: string | null;
  copyMessage?: string;
  openInNewTab?: boolean;
};

const TruncatedCopyValue = ({
  value,
  copyMessage = "Copied to clipboard",
  openInNewTab = false,
}: TruncatedCopyValueProps) => {
  if (!value) {
    return (
      <span className="text-text-base text-[12px] font-normal">- -</span>
    );
  }

  return (
    <div className="flex flex-row items-center gap-[4px]">
      <span className="text-text-base text-[12px] font-normal whitespace-nowrap">
        {truncateMiddle(value)}
      </span>
      {openInNewTab && (
        <button
          type="button"
          onClick={() => window.open(value, "_blank", "noopener,noreferrer")}
          className="flex items-center justify-center text-text-button-primary"
          title="Open in new tab"
        >
          <span className="material-symbols-outlined text-[12px]">
            open_in_new
          </span>
        </button>
      )}
      <CopyButton copyText={value} copyMessage={copyMessage} />
    </div>
  );
};

export default TruncatedCopyValue;
